<template>
  <table class="w-full">
    <thead v-if="canShowHeader">
      <tr>
        <th class="h-10 px-2 py-2" v-for="i in numberOfColumns" :key="i">
          <skeleton-loader class="mb-0" height="1.25rem" />
        </th>
      </tr>
    </thead>
    <tbody :class="canShowHeader ? 'border-t-2 border-b-2 border-solid border-quaternary-800' : 'border-b-0'">
      <tr v-for="i in numberOfRows" :key="i">
        <td class="h-10 px-2 py-2" v-for="j in numberOfColumns" :key="j">
          <skeleton-loader class="mb-0" width="75%" height="1.25rem" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import SkeletonLoader from '@/components/ContentLoader/components/SkeletonLoader.vue'

export default {
  name: 'SkeletonTable',

  components: {
    SkeletonLoader
  },

  props: {
    numberOfColumns: {
      type: Number,
      default: 5
    },
    numberOfRows: {
      type: Number,
      default: 5
    },
    canShowHeader: {
      type: Boolean,
      default: true
    }
  }
}
</script>
